import {routerReducer} from 'react-router-redux';
import { combineReducers } from 'redux';
import ajaxReducer from './ajaxReducer';
import clubReducer from './clubReducer';
import eventReducer from './eventReducer';
import regReducer from './regReducer';
import userReducer from './userReducer';
import reportReducer from './reportReducer';


const rootReducer = combineReducers({
  users: userReducer,
  events: eventReducer,
  clubs: clubReducer,
  registration: regReducer,
  reports: reportReducer,
  ajaxReducer,
  routing: routerReducer,
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/